import { NgModule } from '@angular/core';
import { IonInputFocusFixDirective } from './ion-input-focus-fix.directive';

@NgModule({
  declarations: [IonInputFocusFixDirective],
  exports: [IonInputFocusFixDirective]
})
export class IonInputFocusFixModule {}
